import React from "react";
import CreativeNameDisplay from "../shared/CreativeNameDisplay";

function SpecialsPreview({ preview }) {
  const buttonText = preview?.button_text || "Learn More";
  const sampleAdCreative = {
    appName: "Way2news",
    tagline: "India Reads Way2news",
  };
const designType = preview?.design_type ||  preview.gallery?.design_type || "1"
  return (
    
    <div className="download-preview">
      <CreativeNameDisplay preview={preview} />

      <div className="preview-inner !bg-black !p-6 !py-4 !rounded-[46px]">
        {/* Top section: simulated news article */}
          <div className="bg-gray-800 rounded-lg p-4 mb-3 relative !h-[40%]">
          <div className="flex justify-end gap-2 mb-3">
            <div className="w-6 h-6 bg-gray-500 rounded-full flex items-center justify-center text-white text-sm">
              i
            </div>
            <div className="w-6 h-6 flex flex-col justify-center items-center gap-1">
              <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
              <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
              <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
            </div>
          </div>

          <div className="bg-white rounded-lg p-3 mb-3">
            <div className="flex gap-3">
              <div className="flex-1">
                <div className="space-y-2">
                  <div className="h-2 bg-gray-200 rounded"></div>
                  <div className="h-2 bg-gray-200 rounded w-4/5"></div>
                  <div className="h-2 bg-gray-200 rounded w-2/3"></div>
                </div>
              </div>
              <div className="w-8 h-12 border-2 border-gray-300 rounded-lg flex items-center justify-center">
                <div className="w-4 h-6 bg-gray-100 rounded-sm"></div>
              </div>
            </div>
          </div>

          <div className="text-center">
            <h3 className="text-white text-xl font-bold mb-1">
              {sampleAdCreative.appName}
            </h3>
            <p className="text-gray-300 text-sm">{sampleAdCreative.tagline}</p>
          </div>

        </div>

        {/* Bottom section: Special ad card */}
        <div className={`bg-white border-t border-gray-100 shadow-lg mx-2 mb-4 rounded-xl overflow-hidden ${preview?.design_type === "2" ? "" : "d-flex align-items-stretch"}`}>
          {/* Ad image */}
          <div className={`h-[280px] shrink-0 bg-gray-200 relative overflow-hidden`} style={{ width: +preview?.gallery?.design_type === 2 ? "100%" : "90px", maxWidth: +preview?.gallery?.design_type === 2 ? "300px" : "90px" }}>
            {(
              <img
                src={+preview?.gallery?.design_type === 2 ? preview?.img_url || preview?.img_urls : preview?.video_urls}
                alt="special"
                className="w-full h-full object-cover"
              />
            )}
            <div className="absolute top-2 right-2 bg-gray-200 text-gray-600 text-2xs px-1.5 py-0.5 rounded">
              Ad
            </div>
          </div>

          {/* Ad content — flex column matches image height; CTA uses mt-auto (no overlap with banner) */}
          {+preview?.gallery?.design_type === 1 && (
            <div className="flex flex-1 flex-col min-w-0 min-h-[280px] p-3">
              <div className="min-h-0 flex-1">
                <p className="text-md font-bold text-gray-900 leading-tight mb-1 line-clamp-2">
                  {preview?.head_line || "Special Ad Title"}
                </p>
                <p className="text-xs text-gray-600 leading-snug mb-1 line-clamp-3">
                  {preview?.description || "Enter your description here to see the preview."}
                </p>
                <p className="text-xs text-gray-400">{preview?.gallery?.event_date || "12 days ago"}</p>
              </div>
              {preview?.button_enabled !== false && (
                <button
                  type="button"
                  className="mt-auto w-full shrink-0 bg-blue-500 text-white text-xs font-semibold py-2.5 px-3 rounded-full shadow-sm hover:bg-blue-600 transition-colors"
                >
                  {buttonText}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SpecialsPreview;
